export const baseLineOption = {
  color: ['#69C0FF', '#8ADE52'],
  legend: {
    left: '20px',
    top: '10px',
    itemWidth: 8,
    itemHeight: 8,
    icon: 'rect'
  },
  tooltip: {
    trigger: 'axis'
  },
  grid: {
    top: '90px',
    bottom: '67px',
    left: '120px',
    right: '120px'
  },
  xAxis: {
    type: 'category',
    data: []
  },
  yAxis: {
    type: 'value',
    axisLabel: {
      formatter: ''
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    name: '',
    nameTextStyle: {
      color: '#303133',
      fontSize: 14,
      fontWeight: 500,
      padding: [0, 50, 10, 0]
    },
    minInterval: 1
  },
  series: [
    {
      name: '',
      data: [],
      type: 'line',
      smooth: true
    }
  ]
};
